module.exports = __webpack_public_path__ + "img/12_26.de1ee5f2.png";